const initializeSoftphone = () => {
    // Softphone is not supported on Web
    return (dispatch) => {}
};

export const teardownSoftphone = () => {};

export default initializeSoftphone;
